import 'babel-polyfill'
import App from './app'
